import auth from "../middlewares/auth";
export const board = [
    {
        path: '/board',
        component: () => import(/* webpackChunkName: "board" */ '../views/board/Index'),
        name: 'board',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/board/add',
        component: () => import(/* webpackChunkName: "board" */ '../views/board/Form'),
        name: 'board_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/board/edit/:id',
        component: () => import(/* webpackChunkName: "board" */ '../views/board/Form'),
        name: 'board_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
